import React, { lazy, Suspense } from 'react';
import totalData from '../../json/data.json';

// Lazy load DynamicForm
const DynamicForm = lazy(() => import('../../components/DynamicForm/DynamicForm'));

const AddProjectsPage = () => {
  const fields = totalData["19"].AdminProjects;
  const apiUrl = 'https://pranusha.vercel.app/projects';
  const successRedirect = '/admin/projects';

  return (
    <div>
      <Suspense fallback={<p>Loading form...</p>}>
        <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
      </Suspense>
    </div>
  );
};

export default AddProjectsPage;
